import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchRoutePermissions } from '../services/permissionService';
import { useAuth } from './AuthContext'; // Importar el contexto de autenticación

interface PermissionsContextType {
    permissions: Record<string, string[]>;
    loading: boolean;
}

const PermissionsContext = createContext<PermissionsContextType>({ permissions: {}, loading: true });

export const PermissionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [permissions, setPermissions] = useState<Record<string, string[]>>({});
    const [loading, setLoading] = useState(true);
    const { isAuthenticated } = useAuth(); // SOLO usar isAuthenticated (eliminar authLoading)

    useEffect(() => {
        // Solo cargar permisos si está autenticado
        if (!isAuthenticated) {
            setLoading(false);
            return;
        }

        setLoading(true);
        fetchRoutePermissions()
            .then(list => {
                const map: Record<string, string[]> = {};
                list.forEach(rp => { 
                    map[rp.path] = rp.allowed_roles; 
                });
                setPermissions(map);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, [isAuthenticated]); // Depender del estado de autenticación

    return (
        <PermissionsContext.Provider value={{ permissions, loading }}>
            {children}
        </PermissionsContext.Provider>
    );
};

export const usePermissions = () => useContext(PermissionsContext);